import React from "react";

export default function ValidationError({ error, className = "" }) {
  return <div className={`validation --error ${className}`}>{error}</div>;
}
